import { styled, Switch } from "@mui/material";

export const Switcher = styled(Switch)(({ theme }) => ({
  width: "2.5rem",
  height: "1.25rem",
  padding: 0,
  display: "flex",
  borderRadius: "0.75rem",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: "1.5rem",
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(20px)",
    },
  },
  "& .MuiSwitch-thumb": {
    width: "1rem",
    height: "1rem",
    borderRadius: "0.5rem",
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    height: "1.25rem",
    width: "2.5rem",
    borderRadius: "0.5rem",
    opacity: 1,
    backgroundColor:
      theme.palette.mode === "dark"
        ? "rgba(255,255,255,.35)"
        : "rgba(0,0,0,.25)",
    boxSizing: "border-box",
  },
}));
